import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';

import {
    Grid,
    Typography,
    TextField,
    Paper,
    IconButton,
    InputAdornment,
    Divider,
    Link,
    TableBody,
    TableCell,
    TableContainer,
    Table,
    TableRow,
    TableHead,
    Button
} from '@material-ui/core';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { Pagination } from './components';

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'rgba(0, 0, 0, 0.02)'
        }
    },
    hover: {
        '&$hover:hover': {
            backgroundColor: 'rgba(41, 121, 255, 0.08)'
        }
    },
    selected: {
        '&$selected, &$selected:hover': {
            backgroundColor: 'rgba(41, 121, 255, 0.15)',
            cursor: 'auto'
        }
    }
}))(TableRow);

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#e1f0fb',
        color: '#3f51b5'
    }
}))(TableCell);

const styles = theme => ({
    root: {
        padding: theme.spacing(4)
    },
    paperContent: {
        padding: theme.spacing(3)
    }
});

class TemplateTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            rows: [],
            isLoading: true,
            records: 0,
            page: 1,
            searchValue: '',
            numberOfPages: 0
        };
    }

    componentDidMount = () => {
        this.getData();
    };

    getBack = () => {
        const { history } = this.props;
        history.goBack();
    };

    componentDidUpdate(prevProps, prevState) {
        if (
            (this.state.isLoading && prevState.isLoading != this.state.isLoading) ||
            (!this.props.params.method && this.props.params.method != prevProps.params.method)
        ) {
            this.getData();
        }
    }

    getData = () => {
        const { page, searchValue } = this.state;

        const formData = new FormData();
        formData.append('search', searchValue);
        formData.append('page', page);

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/attendance-point/`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.props.setRecords(data.records);
                this.setState({
                    ...data,
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    isLoading: false
                });
                console.error(error);
                alert('Echec de la récupération des données');
            });
    };

    handleSearch = ({ target: { value } }) => {
        this.setState({
            searchValue: value,
            page: 1,
            isLoading: true
        });
    };

    handlePagination = selectedPage => {
        this.setState({
            page: selectedPage,
            isLoading: true
        });
    };

    delete = (id, period) => {
        let _confirm = window.confirm(
            `Êtes-vous sûre de vouloir supprimer la période du ${period} ?`
        );

        if (_confirm) {
            fetch(
                `https://www.${
                    window.location.hostname.split('.')[1]
                        ? window.location.hostname.split('.')[0] === 'www'
                            ? window.location.hostname.split('.')[1]
                            : window.location.hostname.split('.')[0]
                        : 'dev'
                }.api.digitmarche.fr/api/attendance-point/delete/${id}`,
                {
                    method: 'GET'
                }
            )
                .then(response => {
                    return response.ok ? response.json() : false;
                })
                .then(data => {
                    this.getData();
                })
                .catch(error => {
                    this.setState({
                        isLoading: false
                    });
                    console.error(error);
                    alert('Echec de la suppression.');
                });
        }
    };

    render() {
        const { classes, page, numberOfPages, records, searchValue, rows } = this.state;

        return (
            <Paper className={classes.paperContent}>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="stretch"
                    spacing={3}>
                    <Grid item>
                        <Grid container direction="row" alignItems="baseline">
                            <Grid item>
                                <IconButton onClick={this.getBack}>
                                    <ArrowBackIcon />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography>
                                    <Link component={RouterLink} to="/settings">
                                        Les paramètres
                                    </Link>{' '}
                                    / Gestion des points d'assiduité
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Divider />
                    </Grid>
                    <Grid item>
                        <Typography variant="body1" color="primary">
                            Nombre de résultat : {records}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <TableContainer>
                            <Table stickyHeader size="small" className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align={'left'}>Période</StyledTableCell>
                                        <StyledTableCell align={'center'}>
                                            Nombre de points par présence
                                        </StyledTableCell>
                                        <StyledTableCell align={'center'}>
                                            Nombre de points par placement
                                        </StyledTableCell>
                                        <StyledTableCell align={'left'}>
                                            Commentaire
                                        </StyledTableCell>
                                        <StyledTableCell align={'center'}>Actions</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => {
                                        return (
                                            <StyledTableRow hover key={index}>
                                                <TableCell key={`${index}_periode`} align="left">
                                                    {row.period}
                                                </TableCell>
                                                <TableCell
                                                    key={`${index}_point_present`}
                                                    align="center">
                                                    {row.pointByPresent}
                                                </TableCell>
                                                <TableCell
                                                    key={`${index}_point_placement`}
                                                    align="center">
                                                    {row.pointByPlacement}
                                                </TableCell>
                                                <TableCell key={`${index}_comment`} align="left">
                                                    {row.comment}
                                                </TableCell>
                                                <TableCell key={`${index}_action`} align="center">
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        justify="center"
                                                        direction="row"
                                                        spacing={1}>
                                                        <Grid item>
                                                            <Button
                                                                component={RouterLink}
                                                                to={`/settings/attendance-point/edit/${row.id}`}
                                                                color="primary"
                                                                variant="outlined"
                                                                size="small">
                                                                Modifier
                                                            </Button>
                                                        </Grid>
                                                        <Grid item>
                                                            <Button
                                                                onClick={() =>
                                                                    this.delete(row.id, row.period)
                                                                }
                                                                color="primary"
                                                                style={{
                                                                    color: 'red',
                                                                    borderColor: 'red'
                                                                }}
                                                                variant="outlined"
                                                                size="small">
                                                                Supprimer
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </TableCell>
                                            </StyledTableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item>
                        <Pagination
                            numberOfPages={numberOfPages}
                            currentPage={page}
                            handlePagination={this.handlePagination}
                        />
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

export default withStyles(styles)(TemplateTable);
